/* eslint-disable jsx-a11y/no-autofocus */
import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { Modal } from 'src/client/components/ui/Modal';
import { StyledButton as Button } from 'src/client/components/ui/Button';

const Wrap = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: fixed;
  left: 0;
  height: 100%;

  .modal-body-wrap {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 300px;
    text-align: center;
    border-radius: 5px;
    margin-top: 90px;
    background-color: ${(props) => props.theme.primary6};
    color: ${(props) => props.theme.primary4};

    input {
      margin: 10px;
      height: 40px;
      width: 70px;
      border-radius: 4px;
      text-align: center;
    }

    input:focus {
      outline: none;
    }

    span {
      margin: 20px;
    }
  }
`;

const Div = styled.div`
  max-width: 600px;
  position: relative;

  @media screen and (max-width: 797px) {
    width: 90%;
    max-width: none;
  }

  .go-button {
    width: 100px;
    padding: 8px 0;
    margin: 10px 0 24px;
    font-size: 1rem;
  }
`;

type Props = {
  active?: boolean;
  closeModal?: () => void;
  totalPages?: number | null;
  setPage?: (pageNumber: number) => void;
};

export const PaginationModal = (props: Props) => {
  const { active = false, closeModal = () => {}, totalPages = null, setPage = () => {} } = props;
  const initialValue = '' as const;
  const [inputValue, setInputValue] = useState<number | ''>(initialValue);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  if (!active) {
    return null;
  }

  const maxPages = totalPages ?? 0;
  const pageWithinBounds = (pageNumber: number) => pageNumber <= maxPages && pageNumber > 0;

  const close = () => {
    setInputValue(initialValue);
    closeModal();
  };

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const pageNumber = parseInt(e.target.value, 10);
    const nextValue = Number.isNaN(pageNumber) ? initialValue : pageNumber;
    setInputValue(nextValue);
    setButtonDisabled(!pageWithinBounds(pageNumber));
  };

  const handleOnClick = () => {
    if (typeof inputValue === 'number') {
      setPage(inputValue);
      close();
    }
  };

  const handleOnKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (typeof inputValue !== 'number' || !pageWithinBounds(inputValue)) {
      return false;
    }

    const enterKey = e.key === 'Enter';
    if (enterKey) {
      setPage(inputValue);
      close();
    }
    return true;
  };

  return (
    <Wrap onClose={closeModal}>
      <Div className="modal-body-wrap">
        <span>Jump to Page (1 - {maxPages})</span>
        <input
          type="tel"
          pattern="[0-9]*"
          onChange={handleOnChange}
          onKeyPress={handleOnKeyPress}
          autoFocus
          value={inputValue}
        />
        <Button className="go-button btn-primary" onClick={handleOnClick} disabled={buttonDisabled}>
          Go
        </Button>
      </Div>
    </Wrap>
  );
};
